import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogViewEvent = () => {
  useEffect(() => {
    bridge.logAnalyticsEvent({
      name: 'VIEW_POINT_OF_CONTACT',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'POINT_OF_CONTACT',
      },
    });
  }, []);
};
